module.exports = __webpack_public_path__ + "img/2.6b272dd.webp";